export enum DomainClassification {
  Business = 'Business',
  Personal = 'Personal',
  Unknown = 'Unknown',
}

export enum DomainConfirmationStatus {
  Confirmed = 'Confirmed',
  Undetermined = 'Undetermined',
}

export enum DomainBanStatus {
  Banned = 'Banned',
  Not_Banned = 'Not Banned',
}

export enum BanConfirmationStatus {
  Confirmed = 'Confirmed',
  Undetermined = 'Undetermined',
}

export enum ADD_DOMAIN_MODAL {
  DOMAIN = 'domain',
  SUB_DOMAIN = 'subDomain',
  PARENT_DOMAIN = 'parentDomain',
}

export enum DomainFilterType {
  Children = 'Children',
  Subdomains = 'Subdomains',
}

export enum PageRoutesEnum {
  MAGIC_LINK_AUTH = '/magic-link-auth',
  LOGIN = '/login',
  REGISTRATION = '/registration',
}
